export const addPreconnectTag = (url = "") => {
    if(url) {
        const preconnectTag = document.createElement("link");
        preconnectTag.rel = "preconnect";
        preconnectTag.href = url;
        document.head.appendChild(preconnectTag);
    }
} 